module.exports = __webpack_public_path__ + "img/vps6.9e423a9.png";